import { atomFamily } from "jotai/utils";

import { CarPart } from "types/CarPart";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionSelectedDamagedPartsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<CarPart[]>(`damagedParts-${sessionId}`, [])
);
export const selectedDamagedPartsAtom = createDerivedSessionAtom<CarPart[]>(sessionSelectedDamagedPartsAtom);

const sessionAllDamagedPartsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<CarPart[]>(`allDamagedParts-${sessionId}`, [])
);
export const allDamagedPartsAtom = createDerivedSessionAtom<CarPart[]>(sessionAllDamagedPartsAtom);
